/**
 * The HTML an org's section on its public site may hold: plain structure the
 * site's own stylesheet sets, and nothing that carries a look of its own.
 *
 * No `style`, no `class`: a section reads as part of the site because only the
 * site styles it. Its heading is the section's title, so a heading inside sits
 * under it. A link goes to the web or to mail; an image is shown from an https
 * address, and says what it shows.
 *
 * The server stores through this and the page draws through it, so what is
 * held is what may be shown.
 */
export const SITE_HTML = {
  tags: [
    'p',
    'br',
    'h3',
    'h4',
    'strong',
    'em',
    'u',
    'a',
    'ul',
    'ol',
    'li',
    'blockquote',
    'hr',
    'img',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
  ],
  attributes: {
    '*': ['dir'],
    a: ['href'],
    ol: ['start'],
    img: ['src', 'alt'],
  } as Record<string, string[]>,
  /** Where a link may go. */
  linkSchemes: ['https', 'mailto'],
  /** Where an image may be shown from. */
  imageSchemes: ['https'],
} as const

/** The scheme an address names, lowercased; null for a relative address. */
export function addressScheme(address: string): string | null {
  return (
    /^([a-z][a-z\d+.-]*):/i.exec(address.trim())?.[1]?.toLowerCase() ?? null
  )
}
